<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <section>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-page-title-layout">
              <div>
                <h1 class="boss-page-title boss-page-title-layout-title">
                  セミナー応募者へメッセージを一括送信
                </h1>
              </div>
            </div>
          </div>
          <Accordion
            :is-open="isOpen"
            class="pega-visible"
          >
            <template #head>
              {{ `送信対象者一覧（全${entryIds.length}名）` }}
            </template>
            <template #body>
              <div>
                <div class="boss-table-wrap">
                  <table class="boss-table-4">
                    <tr>
                      <th>応募日</th>
                      <th>応募者</th>
                      <th>セミナー</th>
                      <th>メッセージ</th>
                      <th>ステータス</th>
                      <th>備考</th>
                    </tr>
                    <seminar-entry-bulk-message-target
                      v-for="(entry, i) in entries"
                      :key="i"
                      :entry="entry"
                    />
                  </table>
                </div>
              </div>
            </template>
          </Accordion>
          <!-- メッセージ作成コンポーネント -->
          <seminar-entry-message-register
            :entry-ids="entryIds"
          />
          <!-- メッセージ作成コンポーネント -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SeminarEntryBulkMessageTarget from '@/components/molecules/SeminarEntryBulkMessageTarget'
import SeminarEntryMessageRegister from '@/components/organisms/SeminarEntryMessageRegister'
import Accordion from '@/components/atoms/Accordion'

export default {
  components: {
    Accordion,
    SeminarEntryBulkMessageTarget,
    SeminarEntryMessageRegister
  },
  props: {
    entryIds: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      entries: [],
      isOpen: true
    }
  },
  created () {
    this.$http.secured.post('/seminar/entries', this.entryIds)
      .then(response => {
        this.entries = response.data
      })
  }
}
</script>
